<template>
  <v-form ref="form" :value="valid" @input="v => $emit('update:valid', v)">
    <v-row dense align="center" justify="space-between">
      <v-col cols="12" sm="6">
        <v-text-field
          filled
          dense
          class="no-before"
          :value="nom"
          label="Nom"
          required
          hide-details="auto"
          :rules="[
            v => v !== undefined || 'Un nom est requis',
            v => v !== null || 'Un nom est requis',
            v => v !== ' ' || 'Un nom est requis',
            v => v.length > 0 || 'Un nom est requis'
          ]"
          @change="v => $emit('update:nom', v)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" v-show="est_intermediaire === false">
        <j-decimal-input
          filled
          dense
          class="no-before"
          hide-details
          :min="0"
          :value="prix_vente"
          @input="v => $emit('update:prix_vente', v)"
          label="Prix de vente"
        ></j-decimal-input>
      </v-col>
      <v-col cols="12" sm="2">
        <v-text-field
          filled
          dense
          class="no-before"
          hide-details
          :value="recipeCost"
          suffix="$"
          label="Coût"
          readonly
          background-color="rgba(0, 0, 0, 0.02)"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="2" v-show="est_intermediaire === false">
        <v-text-field
          filled
          dense
          class="no-before"
          hide-details
          :value="percentCost"
          suffix="%"
          label="Cost (Coût/Prix)"
          readonly
          background-color="rgba(0, 0, 0, 0.02)"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "RecipeFields",
  props: {
    nom: {
      required: true
    },
    est_intermediaire: {
      required: true
    },
    prix_vente: {
      required: true
    },
    recipeCost: {
      required: true
    },
    percentCost: {
      required: true
    },
    valid: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters(["getAllowedUnits", "getRecipes"])
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style lang="scss" scoped></style>
